<template>
  <div class="page-index">
    <!-- PC -->
    <swiper class="swiper pc-class" :options="swiperOption" ref="swiper">
      <swiper-slide class="swiper-slide-first">
       
      </swiper-slide>
      <swiper-slide class="swiper-slide-second">
        
      </swiper-slide>
      <swiper-slide class="swiper-slide-three">
        
      </swiper-slide>
      <swiper-slide class="swiper-slide-four">
        
      </swiper-slide>
      <swiper-slide class="swiper-slide-five">
       
      </swiper-slide>
      <swiper-slide class="swiper-slide-six">
        
      </swiper-slide>
    </swiper>
  </div>
</template>
<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import "@/assets/css/base.scss";
import "@/assets/css/rem/index.scss";
import "@/assets/css/rem/indexAdapter.scss";
export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      swiperOption: {
        slidesPerView: 1,
        mousewheelControl: true,
        direction: "vertical",
        observer: true,
      },
    };
  },
};
</script>
<style lang="scss" scoped>
.swiper {
  background-color: #2b3358;
  background-size: cover;
  height: 100vh;
  .swiper-slide-first {
    height: 100vh;
    position: relative;
    background: url('http://theoneart-public.oss-cn-qingdao.aliyuncs.com/tom-cat/first-bg.jpg') no-repeat center center;
    background-size: cover;

  }
}
</style>
